const copyToClipboard = (text) => {
  if (!text) {
    return "-";
  }
  navigator.clipboard.writeText(text);
};

export default copyToClipboard;
